import {ChangeDetectorRef, Component, HostListener, forwardRef, inject, input} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SideSelectionType } from '../../../models/side-selection-type.enum';
import { OrderedIngredient } from '../../../models/ordering/ordered-ingredient.model';
import { AuditService } from '../../../services/audit.service';

@Component({
  selector: 'cwo-side-selection',
  standalone: true,
  imports: [],
  templateUrl: './side-selection.component.html',
  styleUrl: './side-selection.component.scss', 
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SideSelectionComponent),
      multi: true,
    }
  ]
})
export class SideSelectionComponent implements ControlValueAccessor{
  onChange = (val: SideSelectionType | null) => {
    return val};
  onTouch = () => {return undefined};
  orderedIngredient = input<OrderedIngredient>();
  allowDeselect = input(false);
  disableWhole = input(false);
  disableLeft = input(false);
  disableRight = input(false);
  sideSelectionType = SideSelectionType;
  cdRef = inject(ChangeDetectorRef);
  radioGroupName = input.required<string>();
  private auditService = inject(AuditService);
  value: SideSelectionType | null = null;

  @HostListener('focusout')
  onFocusOut() {
    this.onTouch();
  }

  onOptionClick(option: SideSelectionType, event: MouseEvent) {
    if (this.allowDeselect() && this.value === option) {
      const input = event.target as HTMLInputElement;
      input.checked = false;
      this.value = null;
      this.onChange(null);
      this.cdRef.detectChanges();
      this.auditService.createAudit(() =>
        `Deselected '${option}-half' for ingredient '${this.orderedIngredient()?.ingredient}'`
      );
    } else {
      this.value = option;
      this.onChange(option);
      this.auditService.createAudit(() =>
        `Ordered '${option!== 'Whole' ? `${option}-half`: option}' for ingredient '${this.orderedIngredient()?.ingredient}'`
      );
    }
  }
  
  writeValue(obj: any): void {
    this.value = obj ?? null;
    this.cdRef.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  
}
